import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  TextField,
  Chip,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper,
  Divider,
  InputAdornment,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

import { styles } from "./styles.js";

const faqData = [
  {
    id: 1,
    category: "General",
    question: "What is your return policy?",
    answer: "We offer a 30-day money-back guarantee on all purchases.",
    imgPath: "",
  },
  {
    id: 12,
    category: "General",
    question: "What is your return policy?",
    answer: "We offer a 30-day money-back guarantee on all purchases.",
    imgPath: "",
  },
  {
    id: 13,
    category: "General",
    question: "What is your return policy?",
    answer: "We offer a 30-day money-back guarantee on all purchases.",
  },
  {
    id: 2,
    category: "Billing",
    question: "What payment methods do you accept?",
    answer: "We accept all major credit cards and UPI.",
  },
  {
    id: 22,
    category: "Billing",
    question: "What payment methods do you accept?",
    answer: "We accept all major credit cards and UPI.",
  },
  {
    id: 24,
    category: "Billing",
    question: "What payment methods do you accept?",
    answer: "We accept all major credit cards and UPI.",
  },
  {
    id: 3,
    category: "Technical",
    question: "Is there a mobile app available?",
    answer: "Yes, our app is available for Android and iOS.",
  },
  {
    id: 33,
    category: "Technical",
    question: "Is there a mobile app available?",
    answer: "Yes, our app is available for Android and iOS.",
  },
  {
    id: 30,
    category: "Technical",
    question: "Is there a mobile app available?",
    answer: "Yes, our app is available for Android and iOS.",
  },
];

export default function FaqPage() {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [expanded, setExpanded] = useState(false);

  const categories = [...new Set(faqData.map((f) => f.category))];

  const filteredFAQs = faqData.filter((faq) => {
    const matchesSearch =
      faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory =
      !selectedCategory || faq.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const handleAccordionChange = (id) => (_, isExpanded) => {
    setExpanded(isExpanded ? id : false);
  };

  return (
    <Box sx={styles.pageContainer}>
      <Container maxWidth="lg">
        {/* Header */}
        <Box sx={styles.headerBox}>
          <Typography variant="h1" sx={styles.title}>
            Frequently Asked Questions
          </Typography>
          <Typography sx={styles.subtitle}>
            Find quick answers to common questions
          </Typography>

          <TextField
            fullWidth
            placeholder="Search for answers..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            sx={styles.searchField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={styles.searchIcon} />
                </InputAdornment>
              ),
            }}
          />

          <Stack sx={styles.categoryStack}>
            <Chip
              label="All"
              onClick={() => setSelectedCategory(null)}
              sx={styles.categoryChip(selectedCategory === null)}
            />
            {categories.map((category) => (
              <Chip
                key={category}
                label={category}
                onClick={() => setSelectedCategory(category)}
                sx={styles.categoryChip(selectedCategory === category)}
              />
            ))}
          </Stack>
        </Box>

        {/* FAQ Section */}
        {filteredFAQs.length ? (
          <Box sx={styles.faqContainer}>
            {filteredFAQs.map((faq) => (
              <Accordion
                key={faq.id}
                expanded={expanded === faq.id}
                onChange={handleAccordionChange(faq.id)}
                sx={styles.accordion(expanded === faq.id)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={styles.expandIcon} />}
                  sx={styles.accordionSummary}
                >
                  <Box>
                    <Chip
                      label={faq.category}
                      size="small"
                      sx={styles.categoryBadge}
                    />
                    <Typography sx={styles.questionText}>
                      {faq.question}
                    </Typography>
                  </Box>
                </AccordionSummary>
                <AccordionDetails sx={styles.accordionDetails}>
                  <Typography sx={styles.answerText}>{faq.answer}</Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        ) : (
          <Paper sx={styles.noResultsPaper}>
            <HelpOutlineIcon sx={styles.noResultsIcon} />
            <Typography sx={styles.noResultsTitle}>No FAQs found</Typography>
            <Typography color="text.secondary">
              Try adjusting your search
            </Typography>
          </Paper>
        )}

        {/* Contact Section */}
        <Paper sx={styles.contactPaper}>
          <Box sx={styles.contactContentBox}>
            <Typography sx={styles.contactTitle}>
              Still have questions?
            </Typography>
            <Typography sx={styles.contactDescription}>
              Our support team is here to help
            </Typography>
            <Divider sx={styles.contactDivider} />
            <Stack sx={styles.contactStack}>
              <Box>
                <Typography sx={styles.contactLabel}>Email</Typography>
                <Typography sx={styles.contactValue}>
                  support@example.com
                </Typography>
              </Box>
              <Box>
                <Typography sx={styles.contactLabel}>Phone</Typography>
                <Typography sx={styles.contactValue}>
                  +91 90000 00000
                </Typography>
              </Box>
            </Stack>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
